import { Routes } from '@angular/router';

import { LayoutPrincipalComponent } from '@shared/components/layout-principal/layout-principal.component';
import { AdminMinhaContaComponent } from './minha-conta/admin-minha-conta.component';

export const ADMIN_MINHA_CONTA_ROUTES: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        component: AdminMinhaContaComponent,
      },
      {
        path: 'meu-perfil',
        loadChildren: () =>
          import('./meu-perfil/meu-perfil.router').then(
            (m) => m.ADMIN_MEU_PERFIL_ROUTES
          ),
      },
    ],
  },
];
